<nav class="navbar navbar-expand-lg navbar-light bg-white" fixed>
    <div class="container-fluid">
        <!-- Logo et bouton toggle -->
        <div class="d-flex align-items-center">
    <a class="navbar-brand" href="#">
        <nb-actions size="small">
            <nb-action>
                <div class="logo">
                            <a routerLink="/"><img src="./assets/img/logo.png" alt="logo" class="img-fluid"></a>
                </div>
            </nb-action>
        </nb-actions>
    </a>
            <button class="navbar-toggler ms-2" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01"
                aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
        </div>

        <!-- Menu principal -->
        <ul class="menu d-none d-lg-flex flex-wrap">
            <li *ngFor="let item of menuItems" class="menu-item position-relative">
                <a [routerLink]="item.link" class="d-block py-2 px-3">{{ item.label | translate }}</a>
            <!-- Submenu -->
                <ul *ngIf="item.submenu" class="submenu position-absolute start-0 mt-0 bg-white shadow-sm rounded" style="z-index: 1000; min-width: 200px;">
              <li *ngFor="let subItem of item.submenu" class="submenu-item">
                        <a [routerLink]="subItem.link" class="d-block py-2 px-3 text-decoration-none hover-bg-light">{{ subItem.label | translate }}</a>
              </li>
            </ul>
          </li>
        </ul>

        <!-- Éléments de droite -->
        <div class="d-flex align-items-center flex-wrap gap-2">
            <!-- Barre de recherche -->
            <div class="d-none d-md-block">
                <nb-search type="modal-move" nbTooltip="{{ 'HEADER.SEARCH_PLACEHOLDER' | translate }}" 
                    placeholder="{{ 'HEADER.SEARCH_PLACEHOLDER' | translate }}" 
                    hint="{{ 'HEADER.SEARCH_HINT' | translate }}">
                </nb-search>
            </div>

            <!-- Actions -->
            <div class="d-none d-md-flex gap-2">
    <nb-actions size="small">
                    <nb-action icon="car-outline" nbTooltip="{{ 'HEADER.MOVING' | translate }}" 
                        nbTooltipIcon="car-outline" nbTooltipPlacement="bottom" link="/demenagement">
        </nb-action>
    </nb-actions>
    <nb-actions size="small">
                    <nb-action icon="file-add-outline" nbTooltip="{{ 'HEADER.WISHES' | translate }}" 
                        nbTooltipIcon="file-add-outline" nbTooltipPlacement="bottom" link="/desirs">
                    </nb-action>
    </nb-actions>
            </div>

            <!-- Sélecteur de langue -->
    <div class="language-selector">
        <select #langSelect (change)="switchLanguage(langSelect.value)" class="form-control">
            <option value="fr" [selected]="translate.currentLang === 'fr'">Français</option>
            <option value="en" [selected]="translate.currentLang === 'en'">English</option>
        </select>
            </div>
    </div>

        <!-- Menu mobile -->
        <div class="collapse navbar-collapse bg-white" id="navbarTogglerDemo01">
            <ul class="menu d-lg-none mt-2 flex-column w-100">
                <li *ngFor="let item of menuItems" class="menu-item w-100 position-relative">
                    <a [routerLink]="item.link" class="d-block py-2 px-3 w-100">{{ item.label | translate }}</a>
                    <!-- Submenu mobile -->
                    <ul *ngIf="item.submenu" class="submenu w-100 bg-white shadow-sm rounded" style="z-index: 1000;">
                        <li *ngFor="let subItem of item.submenu" class="submenu-item w-100">
                            <a [routerLink]="subItem.link" class="d-block py-2 px-3 w-100 text-decoration-none hover-bg-light">{{ subItem.label | translate }}</a>
                        </li>
                    </ul>
                </li>
            </ul>

            <!-- Actions mobiles -->
            <div class="d-md-none mt-3">
                <div class="d-flex flex-column gap-3">
               
                    <!-- Actions mobiles -->
                    <div class="d-flex flex-wrap gap-3 justify-content-center">
            <nb-actions size="small">
                            <nb-action icon="car-outline" nbTooltip="{{ 'HEADER.MOVING' | translate }}" 
                                nbTooltipIcon="car-outline" nbTooltipPlacement="bottom" link="/demenagement">
                            </nb-action>
            </nb-actions>
            <nb-actions size="small">
                            <nb-action icon="file-add-outline" nbTooltip="{{ 'HEADER.WISHES' | translate }}" 
                                nbTooltipIcon="file-add-outline" nbTooltipPlacement="bottom" link="/desirs">
                            </nb-action>
            </nb-actions>
                    </div>

                    <!-- Sélecteur de langue mobile -->
                    <div class="language-selector w-100">
                        <select #langSelectMobile (change)="switchLanguage(langSelectMobile.value)" class="form-control">
                            <option value="fr" [selected]="translate.currentLang === 'fr'">Français</option>
                            <option value="en" [selected]="translate.currentLang === 'en'">English</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Actions utilisateur -->
            <div class="d-flex flex-column gap-3 mt-3">
                <div class="d-flex flex-wrap gap-2 justify-content-center">
            <nb-actions *ngIf="!isconnected()" size="small">
                        <nb-action icon="person-done-outline" nbTooltip="{{ 'HEADER.PROFILE' | translate }}" 
                            nbTooltipIcon="person-done-outline" nbTooltipPlacement="bottom" link="/profile">
                        </nb-action>
            </nb-actions>
            <nb-actions *ngIf="!isconnected()" size="small" (click)="logout()">
                        <nb-action icon="log-out-outline" nbTooltip="{{ 'HEADER.LOGOUT' | translate }}" 
                            nbTooltipIcon="lock-outline" nbTooltipPlacement="bottom">
                        </nb-action>
            </nb-actions>
                </div>

                <ul class="menu d-flex flex-wrap gap-2 justify-content-center" *ngIf="isconnected()">
                    <li class="menu-item"> 
                        <a (click)="login()" class="d-flex align-items-center gap-1">
                            <nb-icon icon="log-in-outline" style="color: #2cbdb8;"></nb-icon>
                            {{ 'HEADER.LOGIN' | translate }}
                        </a>
                    </li>
                    <li class="menu-item"> 
                        <a (click)="register()" class="d-flex align-items-center gap-1">
                            <nb-icon icon="edit-2-outline" style="color: #2cbdb8;"></nb-icon>
                            {{ 'HEADER.REGISTER' | translate }}
                        </a>
                    </li>
        </ul>
            </div>
        </div>
    </div>
</nav>